module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "isActive": _vm.sidebar.opened,
      "toggleClick": _vm.toggleSideBar
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": _vm.img_user
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.name || _vm.username))])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePassword"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.name8')))])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout",
      "divided": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.name9')))])])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container-logout",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.logout
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('div', {
    staticClass: "exit",
    on: {
      "click": _vm.logout
    }
  }, [_c('icon-svg', {
    attrs: {
      "icon-class": "tuichu"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown-menu', [_c('el-dropdown-item')], 1)], 1)], 1), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "must": _vm.must,
      "isshow": _vm.dialogChangePasswordFormVisible
    },
    on: {
      "close": function($event) {
        _vm.dialogChangePasswordFormVisible = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f076de7c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 555
// module chunks = 313